import { CalendarDays, Clock } from "lucide-react";
import { format } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { INPUT_CLS } from "@/lib/formStyles";

const TIME_SLOTS = ["10:00 AM", "11:30 AM", "1:00 PM", "2:30 PM", "4:00 PM"];

function isDayUnavailable(date) {
  const day = date.getDay();
  return day === 0 || day === 1 || date < new Date(new Date().setHours(0, 0, 0, 0));
}

export function DateTimePicker({ date, time, onDateChange, onTimeChange, calendarOpen, setCalendarOpen }) {
  return (
    <>
      <div className="mt-4">
        <p className="mb-2 text-[10px] font-mono uppercase tracking-[0.2em] text-stone-400">Preferred date</p>
        <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
          <PopoverTrigger asChild>
            <button
              type="button"
              data-testid="booking-date-input"
              className={`${INPUT_CLS} flex items-center justify-between text-left ${!date ? "text-stone-400" : ""}`}
            >
              <span>{date ? format(date, "EEEE, MMMM d, yyyy") : "Select an available date"}</span>
              <CalendarDays size={16} className="text-stone-400 shrink-0" />
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={date}
              onSelect={(d) => { onDateChange(d || null); setCalendarOpen(false); }}
              disabled={isDayUnavailable}
              initialFocus
              data-testid="booking-date-calendar"
            />
          </PopoverContent>
        </Popover>
        <p className="mt-2 text-[10px] text-stone-400">Open Tuesday–Saturday. Sundays &amp; Mondays unavailable.</p>
      </div>

      <div className="mt-4">
        <p className="mb-2 text-[10px] font-mono uppercase tracking-[0.2em] text-stone-400">Preferred time</p>
        <div className="flex flex-wrap gap-2">
          {TIME_SLOTS.map((slot) => (
            <button
              type="button"
              key={slot}
              data-testid={`booking-time-slot-${slot.replace(/[\s:]/g, "")}`}
              aria-pressed={time === slot}
              onClick={() => onTimeChange(slot)}
              className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-medium transition-colors duration-300 ${
                time === slot
                  ? "bg-ink text-alabaster"
                  : "border border-ink/10 text-stone-500 hover:border-gold hover:text-gold"
              }`}
            >
              <Clock size={12} />
              {slot}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
